<style scoped>
img{
    cursor: pointer;
}
.vel-modal {
    z-index: 9998;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    background: rgba(0,0,0,.5)!important;
}
#kurulumTable button{
    float:right
}
.upload-btn-wrapper {
    position: relative;
    display: inline-block;
}
.upload-btn-wrapper input[type=file] {
    font-size: 100px;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    width:50px;
    height:35px
}
</style>
<script>
import VueEasyLightbox from "vue-easy-lightbox";
import Loader from "@/components/widgets/loader.vue";
import { notify } from '@/helpers/notify' 
import Vue from 'vue'

export default {
    name: 'KurulumModal',
    props:[
        "data",
        "modelOpen"
    ],
    components: {
        VueEasyLightbox,
        Loader
  },
    data() {
        return {
            form: {},
            submitted: false,
            dataLoading:true,
            selectedFiles: {},
            images:
                {
                    "kurulum":  { filename:'', id:''},
                    "anten":  { filename:'', id:''},
                    "kapi":  { filename:'', id:''},
                    "adaptor":  { filename:'', id:''},
                },
            rows:[
                { code: 'kurulum', title: 'Anten Kurulum Resmi' },
                { code: 'anten', title: 'Anten Uzaktan Resmi' },
                { code: 'kapi', title: 'Dış Kapı Resmi Görüntüle' },
                { code: 'adaptor', title: 'Adaptör Resmi Görüntüle' },
            ],
            showImage:null,
            imageUrl:this.$http.defaults.baseURL + '/image/'
        };
    }, 
    computed:{
        modalTitle(){ return "Evrak Detayı" },
    }, 
    watch:{
        modelOpen(){
            this.selectedFiles= {},
            this.images=
                {
                    "kurulum":  { filename:'', id:''},
                    "anten":  { filename:'', id:''},
                    "kapi":  { filename:'', id:''},
                    "adaptor":  { filename:'', id:''},
                }
          
            this.showImage= null,
            this.form= {...this.data}
            this.getImages()
        }
    },
    methods: {
        async uploadImage(event, name){
            const file = event.target.files[0];
            const resizedBlob = await this.resizeImage(file, 800); 
            const formData = new FormData();
            formData.append(`images[${name}]`, resizedBlob);
            const response = await this.$http.post('/image?subsId=' + this.form.id, formData, {headers: { 'Content-Type': 'multipart/form-data' }});
          
            if(response.data.error){
               return notify.error(response.data.message)
            }
            
            this.getImages()
            return notify.success(response.data.message)
           
        },

        async resizeImage(file, maxWidth) {
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onload = (readerEvent) => {
                const image = new Image();
                image.onload = () => {
                    const { width, height } = this.calculateAspectRatioFit(image.width, image.height, maxWidth);
                    const canvas = document.createElement('canvas');
                    canvas.width = width;
                    canvas.height = height;
                    canvas.getContext('2d').drawImage(image, 0, 0, width, height);
                    canvas.toBlob((blob) => {
                    resolve(blob);
                    }, file.type);
                };
                image.src = readerEvent.target.result;
                };
                reader.readAsDataURL(file);
            });
        },

        calculateAspectRatioFit(srcWidth, srcHeight, maxWidth) {
            const ratio = maxWidth / srcWidth;
            return { width: maxWidth, height: srcHeight * ratio };
        },

        getImages(){
            this.dataLoading = true
            this.$http.get('/members/' + this.form.id + '/document')
            .then(response => {
                response.data.images.map(e=>{
                    this.images[e.name] = { filename: e.filename, id:e.id}
                })
            })
        },

        close(){
            this.$parent.$bvModal.hide('evrak_modal')
        },

        sil(id, code){
            Vue.swal({
                title: "Silinecek?",
                showCancelButton: true,
                cancelButtonText: "İptal",
                confirmButtonText: "Sil"
            }).then((result) => {
                if (result.value) {
                    this.$http.delete(`/image/` + id)
                    .then(response => {
                        this.images[code] =  { filename:'', id:''}
                        if(response.data.code == 100) return notify.success(response.data.message)
                        
                      
                        return notify.error(response.data.message)
                    })
                }
            });

        },
       
    },
};
</script>

<template>
<b-modal id="evrak_modal"  size="xl" :title="modalTitle"  no-close-on-backdrop hide-footer>
    <Loader :loading="true" :load="dataLoading">
    <div class="row">
         <div class="col-md-5 mt-5">
            <div class="card" v-for="(row,i) in rows" :key=i>
                <div class="row mb-1">
                    <div class="col-md-6">
                        <div class="px-3 py-3">{{ row.title }}</div>
                        <div class="px-3">
                            <button v-if="form.action != 'read'" @click="sil(images[row.code].id, row.code)" class="btn btn-outline-danger btn-sm" style="margin-right:4px">Sil</button>
                            <div class="upload-btn-wrapper">
                                <button for="upload" class="btn btn-outline-success btn-sm" style="margin-right:4px:">Yükle</button>
                                <input type="file" @change="uploadImage($event, row.code)"  name="images[]" accept="image/*" />
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-end">
                        <img @click="showImage = row.code" :src="imageUrl + images[row.code].filename" alt="" width="110">
                        <vue-easy-lightbox
                            :visible="showImage == row.code"
                            :imgs="imageUrl +  images[row.code].filename"
                            @hide="showImage = null"
                        ></vue-easy-lightbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </Loader>
    <div class="d-flex justify-content-between mt-3">
        <b-button 
            type="submit" 
            @click="close"
            variant="secondary" 
            class="ms-1"
            >Kapat
        </b-button>
    </div>
</b-modal>
</template>
